import { Effect, EffectProperties, EffectFields } from '../../core/Effect';
import * as PostProcessing from '@react-three/postprocessing';
import { forwardRef } from 'react';
import * as THREE from 'three';
import { Field } from '@/types/core/Field';

export interface VignetteEffectProperties extends EffectProperties {
  offset: number;
  darkness: number;
}

// Create a reusable Vignette component that can be used in both preview and world
const VignetteComponent = forwardRef<any, { properties: VignetteEffectProperties; isPreview?: boolean }>((props, ref) => {
  const { properties, isPreview } = props;

  if (isPreview) {
    return null;
  }
  
  const { offset, darkness } = properties;

  return (
    <PostProcessing.Vignette
      ref={ref}
      offset={offset}
      darkness={darkness}
    />
  );
});

export const VignetteEffectItem: Effect<VignetteEffectProperties> = {
  id: '',
  name: 'Vignette',
  type: 'effect',
  subtype: 'Vignette',
  icon: 'Effect',
  properties: {
    offset: 0.5,
    darkness: 0.5,
  },
  fields: [
    ...EffectFields,
    {
      key: 'properties.offset',
      type: 'number',
      label: 'Offset',
      default: 0.5,
      panel: 'effect',
    },
    {
      key: 'properties.darkness',
      type: 'number',
      label: 'Darkness',
      default: 0.5,
      panel: 'effect',
    }
  ],
  render: (properties: VignetteEffectProperties, isPreview: boolean, ref: React.RefObject<THREE.Object3D | null>) => {
    return <VignetteComponent properties={properties} isPreview={isPreview} ref={ref as any} />;
  }
};